module.exports = __webpack_public_path__ + "img/presentation_1.a98f227d.jpeg";